export const sampleData = [
    {
        dimension: 'assetClassAllocations',
        allocations: [
            {
                holding: 'Equities',
                allocation: 0.5461743,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-10-31',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'equities',
                    name: 'Equities',
                },
            },
            {
                holding: 'Fixed Income',
                allocation: 0.3642961,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-10-31',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'fixedIncome',
                    name: 'Fixed Income',
                },
            },
            {
                holding: 'Cash and Equivalents',
                allocation: 0.0895295,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-10-31',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'cashAndEquivalents',
                    name: 'Cash and Equivalents',
                },
            },
        ],
    },
    {
        dimension: 'assetClassAllocations',
        allocations: [
            {
                holding: 'Equities',
                allocation: 0.5421686,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-09-30',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'equities',
                    name: 'Equities',
                },
            },
            {
                holding: 'Fixed Income',
                allocation: 0.3828029,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-09-30',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'fixedIncome',
                    name: 'Fixed Income',
                },
            },
            {
                holding: 'Cash and Equivalents',
                allocation: 0.0750286,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-09-30',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'cashAndEquivalents',
                    name: 'Cash and Equivalents',
                },
            },
        ],
    },
    {
        dimension: 'assetClassAllocations',
        allocations: [
            {
                holding: 'Equities',
                allocation: 0.5462628,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-08-31',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'equities',
                    name: 'Equities',
                },
            },
            {
                holding: 'Fixed Income',
                allocation: 0.3780486,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-08-31',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'fixedIncome',
                    name: 'Fixed Income',
                },
            },
            {
                holding: 'Cash and Equivalents',
                allocation: 0.0756876,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-08-31',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'cashAndEquivalents',
                    name: 'Cash and Equivalents',
                },
            },
        ],
    },
    {
        dimension: 'assetClassAllocations',
        allocations: [
            {
                holding: 'Equities',
                allocation: 0.5447381,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-07-31',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'equities',
                    name: 'Equities',
                },
            },
            {
                holding: 'Fixed Income',
                allocation: 0.3775554,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-07-31',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'fixedIncome',
                    name: 'Fixed Income',
                },
            },
            {
                holding: 'Cash and Equivalents',
                allocation: 0.0777063,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-07-31',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'cashAndEquivalents',
                    name: 'Cash and Equivalents',
                },
            },
        ],
    },
    {
        dimension: 'assetClassAllocations',
        allocations: [
            {
                holding: 'Equities',
                allocation: 0.5363065,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-06-30',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'equities',
                    name: 'Equities',
                },
            },
            {
                holding: 'Fixed Income',
                allocation: 0.3825809,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-06-30',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'fixedIncome',
                    name: 'Fixed Income',
                },
            },
            {
                holding: 'Cash and Equivalents',
                allocation: 0.0811134,
                allocationShort: null,
                allocationLong: null,
                effectiveDate: '2022-06-30',
                allocationGross: null,
                benchmarkAllocation: null,
                assetType: {
                    entityId: 'cashAndEquivalents',
                    name: 'Cash and Equivalents',
                },
            },
        ],
    },
];
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.5461743,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-10-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3642961,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-10-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0895295,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-10-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.5421686,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-09-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3828029,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-09-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0750286,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-09-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.5462628,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-08-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3780486,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-08-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0756876,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-08-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.5447381,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-07-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3775554,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-07-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0777063,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-07-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.5363065,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-06-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3825809,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-06-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0811134,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-06-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.5621466,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-05-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3457485,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-05-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0921057,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-05-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.5657805,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-04-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3432031,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-04-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0910163,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-04-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.5835015,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-03-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3387767,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-03-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0777222,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-03-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.5723044,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-02-28',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3499689,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-02-28',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0777261,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-02-28',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.5725481,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-01-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3478559,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-01-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0795954,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2022-01-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.5965139,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-12-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3455116,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-12-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0579739,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-12-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.6014953,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-11-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3519637,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-11-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0465412,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-11-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.636559,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-10-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3207577,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-10-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0426832,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-10-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.6209736,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-09-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3358494,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-09-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0431774,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-09-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.6141838,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-08-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3295614,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-08-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0562535,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-08-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.6273757,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-07-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3350993,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-07-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0375245,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-07-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.6258995,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-06-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3371926,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-06-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0369079,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-06-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.6127564,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-05-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3421598,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-05-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0450843,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-05-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.619509,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-04-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.340698,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-04-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0397939,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-04-30',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
//     {
//         dimension: 'assetClassAllocations',
//         allocations: [
//             {
//                 holding: 'Equities',
//                 allocation: 0.6131466,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-03-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'equities',
//                     name: 'Equities',
//                 },
//             },
//             {
//                 holding: 'Fixed Income',
//                 allocation: 0.3343829,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-03-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'fixedIncome',
//                     name: 'Fixed Income',
//                 },
//             },
//             {
//                 holding: 'Cash and Equivalents',
//                 allocation: 0.0524707,
//                 allocationShort: null,
//                 allocationLong: null,
//                 effectiveDate: '2021-03-31',
//                 allocationGross: null,
//                 benchmarkAllocation: null,
//                 assetType: {
//                     entityId: 'cashAndEquivalents',
//                     name: 'Cash and Equivalents',
//                 },
//             },
//         ],
//     },
// ];
